"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ratio = void 0;
var expression_1 = require("./expression");
var quantity_1 = require("../datatypes/quantity");
var DT = __importStar(require("../datatypes/datatypes"));
var Ratio = /** @class */ (function (_super) {
    __extends(Ratio, _super);
    function Ratio(json) {
        var _this = _super.call(this, json) || this;
        if (json.numerator == null) {
            throw new Error('Cannot create a ratio with an undefined numerator value');
        }
        else {
            _this.numerator = new quantity_1.Quantity(json.numerator.value, json.numerator.unit);
        }
        if (json.denominator == null) {
            throw new Error('Cannot create a ratio with an undefined denominator value');
        }
        else {
            _this.denominator = new quantity_1.Quantity(json.denominator.value, json.denominator.unit);
        }
        return _this;
    }
    Ratio.prototype.exec = function (_ctx) {
        return new DT.Ratio(this.numerator, this.denominator);
    };
    return Ratio;
}(expression_1.Expression));
exports.Ratio = Ratio;
//# sourceMappingURL=ratio.js.map